import { render, staticRenderFns } from "./librosInstitucion.vue?vue&type=template&id=256373a1"
import script from "./librosInstitucion.vue?vue&type=script&lang=js"
export * from "./librosInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports